export default __webpack_public_path__ + "static/media/Atom.9089fcf4.png";